import React from 'react'

const SocialYoutubeIcon = (
  <>
    <path
      d="M39.6006 12.0028C39.6006 12.0028 39.2097 9.24639 38.0104 8.03254C36.4894 6.43936 34.7844 6.43147 34.0025 6.33821C28.4051 5.93359 20.0087 5.93359 20.0087 5.93359H19.9913C19.9913 5.93359 11.5951 5.93359 5.99745 6.33821C5.21553 6.43147 3.51119 6.43936 1.98958 8.03254C0.790292 9.24639 0.400025 12.0028 0.400025 12.0028C0.400025 12.0028 0 15.2398 0 18.4767V21.5114C0 24.7483 0.400033 27.9852 0.400033 27.9852C0.400033 27.9852 0.7903 30.7417 1.98959 31.9555C3.5112 33.5487 5.50992 33.4983 6.40015 33.6653C9.60022 33.9721 20 34.0671 20 34.0671C20 34.0671 28.4051 34.0544 34.0025 33.6498C34.7844 33.5566 36.4894 33.5487 38.0104 31.9555C39.2097 30.7417 39.6006 27.9852 39.6006 27.9852C39.6006 27.9852 40 24.7483 40 21.5114V18.4767C40 15.2398 39.6006 12.0028 39.6006 12.0028Z"
      fill="#DC2217"
    />
    <path
      d="M15.8705 25.1891L15.8687 13.9502L26.6768 19.5892L15.8705 25.1891Z"
      fill="white"
    />
  </>
)

export default SocialYoutubeIcon
